<template>
    <el-container>
      <el-aside :width="isCollapse?'64px':'220px'" style="transition: all 0.6s;">
<!--        <el-scrollbar class="bar-srocll">-->
          <div class="title">
            <div style="display: flex; align-items: center">
              <img src="../assets/image/catLogo.png" alt="" :class="[!isCollapse?'imgB':'imgS']"/>
              <div v-if="!isCollapse">
                <p>以萌宠物</p>
                <p style="font-weight: normal; font-size: 12px; scale: 0.8;letter-spacing: 2px; ">YIMENG SYSTEM</p>
              </div>
            </div>
          </div>
          <div style="margin-bottom: 16px;" v-if="!isCollapse">
            <Search />
          </div>
<!--          <div :class="[!isCollapse?'sideBar':'']">-->
<!--            -->
<!--          </div>-->
          <SideBar />
<!--        </el-scrollbar>-->

      </el-aside>
      <el-container>
        <el-header height="48px">
          <div class="flex-style">
            <CollapseBtn :state="isCollapse" @click="toggleSideBar"/>
<!--            <Search />-->
            <TagsView/>
          </div>
          <div class="flex-style" style="margin-right: 24px;">
            <UserInfo />
          </div>
        </el-header>
        <el-main class="main-container">
<!--          <BackToTop target=".main-container"/>-->
          <AppMain />
        </el-main>
      </el-container>
    </el-container>
</template>

<script>
import SideBar from './components/SideBar'
import Search from './components/Search'
import AppMain from './components/AppMain'
import CollapseBtn from "./components/CollapseBtn";
import UserInfo from "./components/UserInfo"
import TagsView from "./components/TagsView"
import BackToTop from "./components/BackToTop"

export default {
  name: "Layout",
  components: { SideBar, Search, AppMain, CollapseBtn, UserInfo, TagsView, BackToTop },
  data() {
    return {
    }
  },
  computed: {
    isCollapse() {
      return this.$store.state.sidebar.opened
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },
  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped>
.main-container {
  height: calc(100vh - 48px);
  overflow-x: hidden;
}
.title {
  font-family: "微软雅黑", Arial, sans-serif;
  margin: 24px 16px 24px;
  color: #000;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 1px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.tip {
  font-size: 12px;
  font-weight: normal;
  color: rgba(255,255,255,0.3);
}
.flex-style {
  display: flex;
  align-items: center;
}
.sideBar {
  width: 180px;
}

.imgB {
  width: 48px;
  height: 48px;
  //margin-right: 2px;
}


.imgS {
  width: 32px;
  height: 32px
}

.bar-srocll {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

</style>
